var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 117,
    viewBox: "0 0 170 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_322_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.733 51.2673C128.052 40.508 118.724 32.25 107.5 32.25C103.277 32.25 99.22 33.4183 95.7008 35.5973C90.3468 26.5993 80.708 21 70 21C53.4583 21 40 34.4583 40 51C40 51.1025 40 51.2087 40.0037 51.3112C29.3725 53.102 21 62.3708 21 73.5C21 85.9072 31.3427 96 43.75 96H126.25C138.657 96 149 85.9072 149 73.5C149 62.2757 140.492 52.9482 129.733 51.2673Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_322_139",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 128,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.733 51.2673C128.052 40.508 118.724 32.25 107.5 32.25C103.277 32.25 99.22 33.4183 95.7008 35.5973C90.3468 26.5993 80.708 21 70 21C53.4583 21 40 34.4583 40 51C40 51.1025 40 51.2087 40.0037 51.3112C29.3725 53.102 21 62.3708 21 73.5C21 85.9072 31.3427 96 43.75 96H126.25C138.657 96 149 85.9072 149 73.5C149 62.2757 140.492 52.9482 129.733 51.2673Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_322_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7547 49.6761L65.6767 69.7818C64.0584 71.8599 65.5201 74.9771 68.1823 74.9771H73.5591C75.2817 74.9771 76.7956 76.1201 76.7956 77.8345V102.383C76.7956 104.097 78.0484 105.5 79.8233 105.5H88.2799C89.9503 105.5 91.412 104.097 91.412 102.383V77.8345C91.412 76.1201 92.7697 74.9771 94.4919 74.9771H99.8686C102.479 74.9771 103.94 71.8599 102.322 69.8338L86.6616 49.78C85.461 48.1175 83.0075 48.0656 81.7547 49.6761Z",
    fill: "url(#paint0_linear_322_139)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_322_139",
    x: 0,
    y: 0,
    width: 170,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_322_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_322_139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_322_139",
    x1: 85.2636,
    y1: 114.16,
    x2: 86.7659,
    y2: 47.2417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.691cb470b94dae7f667e2b7d38a09a8a.svg";
export { ForwardRef as ReactComponent };